import { render } from "./AppLayoutDefault.vue?vue&type=template&id=b520b27c"
import script from "./AppLayoutDefault.vue?vue&type=script&lang=js"
export * from "./AppLayoutDefault.vue?vue&type=script&lang=js"

import exportComponent from "C:\\OpenServer\\domains\\front-studixy.dm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__